<template>
  <div>
    <div class="container">
      <div class="row" style="margin-bottom: 22px;">
        <div v-if="hasPermission('admin')" class="col-xs-4 col-sm-offset-12">
          <select-widget
              v-model="targetMetric"
              :options="[{value: 'ad_target', label: 'Target'}, {value: 'ad_management_target', label: 'Management Target'}]"
          ></select-widget>
        </div>

        <div class="col-xs-4" :class="hasPermission('admin') ? '' : 'col-sm-offset-16'">
          <TypeaheadWidget
              v-model="user"
              name="user_id"
              endpoint="/api/v2/users"
              :token="shared.token"
              path="data.data"
              placeholder="(all users)"
              :result-label-property="row => row.attributes.full_name"
          />
        </div>

        <div class="col-xs-4">
          <div class="dashboard-date-widget">
            <date-widget :value="year" format="YYYY" original-format="YYYY" @input="navigate"></date-widget>

            <i class="dashboard-date-widget__icon fa fa-sort"></i>
          </div>
        </div>
      </div>

      <hr class="panel-separator">

      <div class="row">
        <div class="col-sm-8">
          <index-number
              :year="year"
              :portal="portal"
              :target-metric="targetMetric"
              :user="user"
          ></index-number>
        </div>

        <div class="col-sm-8">
          <revenue-number
              :year="year"
              :portal="portal"
              :target-metric="targetMetric"
              :user="user"
          ></revenue-number>
        </div>

        <div class="col-sm-8">
          <difference-number
              :year="year"
              :portal="portal"
              :target-metric="targetMetric"
              :user="user"
          ></difference-number>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <channel-overview
              :portal="portal"
              :year="year"
              :filters="filters"
              :target-metric="targetMetric"
              :user="user"
          ></channel-overview>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <monthly-overview
              :year="year"
              :portal="portal"
              :filters="filters"
              :target-metric="targetMetric"
              :user="user"
          ></monthly-overview>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dashboard-date-widget {
  position: relative;
}

.dashboard-date-widget__icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
</style>

<script>
import store from '@/store'
import ChannelOverview from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/ChannelOverview'
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'
import DifferenceNumber from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/DifferenceNumber'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import IndexNumber from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/IndexNumber'
import MonthlyOverview from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/MonthlyOverview'
import Permissions from '@/mixins/Permissions'
import RevenueNumber from '@/pages/Administration/Portals/Edit/Tabs/Dashboard/Panels/RevenueNumber'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TypeaheadWidget from "../../../../../../vendor/forms/FormGroups/Widgets/Typeahead.vue";

export default {
  components: {
    TypeaheadWidget,
    ChannelOverview,
    DateWidget,
    DifferenceNumber,
    HeadlineContainer,
    IndexNumber,
    MonthlyOverview,
    RevenueNumber,
    SelectWidget
  },

  mixins: [Permissions],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'year'],

  data() {
    return {
      targetMetric: 'ad_target',
      user: null,
      shared: store
    }
  },

  computed: {
    filters() {
      return [
        {dimension: 'portal_id', value: this.portal.id},
        {dimension: 'source', value: 'Ads'}
      ]
    }
  },

  methods: {
    navigate(year) {
      this.$router.push(year)
    }
  }
}
</script>
